// ─── Brand Colours ────────────────────────────────────────
export const BRAND_ORANGE = 'hsl(19, 101%, 51%)';
export const BRAND_ORANGE_HOVER = 'rgba(255, 107, 0, 0.15)';
export const BRAND_ORANGE_HEX = '#ff6b00';
export const BRAND_ORANGE_SELECTED_BG = 'rgba(230, 81, 0, 0.25)';
export const BRAND_ORANGE_SELECTED_HOVER = 'rgba(230, 81, 0, 0.35)';

// ─── Environment ──────────────────────────────────────────
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || '';
export const SIGNALR_SCOPE =
  process.env.REACT_APP_MSAL_API_SCOPE || '';
export const APP_ENV =
  process.env.NODE_ENV || 'development';

// ─── Tenant ───────────────────────────────────────────────
export const GLOBAL_ADMIN_TENANT_ID = '__GLOBAL_ADMIN__';
